import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BLACK, WHITE, PAGE_WIDTH } from '../../../styles/variables.style';

export const Wrapper = styled.div`
  background-color: white;
  box-shadow: 0 0 20px -10px black;
  justify-content: center;
  left: 0;
  padding-top: 133px;
  position: absolute;
  top: 0;
  transform: ${({ open, top }) => {
  if (open) return 0;
  else if (top) return 'translateY(-100%)';
  return 'translateY(-100%) translateY(133px)';
}};
  transition: transform 500ms ease-in-out;
  width: 100%;
  z-index: -1;

  &.footerMenu {
    ${media.tabletP`
      position: static;
      padding-top: 0;
    `};
  }
`;

export const DropdownInner = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px auto;
  max-width: 100%;
  opacity: ${({ open }) => (open ? 1 : 0)};
  padding: 0 40px;
  transition: ${({ open }) => (open ? 'opacity 300ms ease-in-out 300ms' : 'opacity 100ms ease-in-out')};
  width: ${PAGE_WIDTH}px;
  background: ${WHITE};

  ${media.desktop`
    margin: 0 auto;
    width: 100%;
    padding: 0 80px;
  `};

  &.footerMenu {
    margin: 0;
    background: ${BLACK};

    ${media.tabletP`
      padding: 0 80px;
    `};
  }
`;

export const Listing = styled.div`
  column-count: 2;
  column-gap: 35px;

  &.footerMenu {
    padding-top: 40px;
    border-top: 1px solid ${WHITE};
  }
`;

export const Category = styled.div`
  display: inline-block;
  margin: 0 10px 30px 0;
  width: 100%;
`;

export const CategoryTitle = styled.h5`
  align-items: center;
  border-bottom: 1px solid #4b4b4b;
  color: ${({ color }) => color};
  display: flex;
  font-family: sans-serif;
  font-size: 16px;
  height: 100%;
  margin: 0 0 10px;
  padding-bottom: 10px;
  text-transform: uppercase;
`;

export const CategoryLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

export const Subcategory = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  letter-spacing: 0.3px;
  width: 100%;
`;

export const SubcategoryTitle = styled.div`
  color: ${({ color }) => color};
  font-family: FuturaStd;
  font-size: 14px;
  letter-spacing: 0.2px;
  margin: 10px 0;

  &:hover {
    text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
  }
`;

export const ItemTitle = styled.p`
  color: ${({ color }) => color};
  cursor: pointer;
  font-size: 12px;
  line-height: 1.2;
  margin: 0 0 10px 0;
  padding-right: 25px;
  text-transform: uppercase;
  width: 50%;

  ${media.desktopLarge`
    width: calc(100% / 3);
  `};

  &:hover {
    text-decoration: underline;
  }
`;

export const CopyRightWrapper = styled.div`
  background: ${BLACK};
`;

export const PlaceholderWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const PlaceholderColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-right: ${({ marginRight }) => marginRight};
`;

export const Hr = styled.hr`
  width: 100%;
  height: 1px;
  background: ${({ color }) => color};
  border: 0;
`;



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Desktop/Dropdown.style.js